import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faAnglesRight,
  faArrowLeftLong,
  faArrowRightArrowLeft,
  faArrowRightLong,
  faArrowsRotate,
  faArrowTrendDown,
  faArrowTrendUp,
  faBaby,
  faBabyCarriage,
  faBagShopping,
  faBasketShopping,
  faBath,
  faBed,
  faBell,
  faBellConcierge,
  faBicycle,
  faBinoculars,
  faBoltLightning,
  faBone,
  faBook,
  faBowlFood,
  faBriefcase,
  faBrush,
  faBuildingColumns,
  faBurger,
  faBus,
  faCableCar,
  faCakeCandles,
  faCalculator,
  faCalendar,
  faCalendarDay,
  faCamera,
  faCar,
  faCarBurst,
  faCaretDown,
  faCarrot,
  faCarSide,
  faCartShopping,
  faCat,
  faChair,
  faChartLine,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faChildren,
  faCircleCheck,
  faCircleDollarToSlot,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlus,
  faCircleQuestion,
  faCircleUser,
  faCircleXmark,
  faClock,
  faCodeFork,
  faCoffee,
  faCoins,
  faComment,
  faCommentsDollar,
  faCompass,
  faCookie,
  faCouch,
  faCheck,
  faCreditCard,
  faDice,
  faDog,
  faDroplet,
  faDumbbell,
  faEarth,
  faEnvelope,
  faEye,
  faFaceSmile,
  faFeather,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileLines,
  faFilePen,
  faFire,
  faFireFlameSimple,
  faFish,
  faFishFins,
  faFlask,
  faFolder,
  faFolderOpen,
  faFolderPlus,
  faFolderTree,
  faFutbol,
  faGamepad,
  faGasPump,
  faGauge,
  faGear,
  faGem,
  faGhost,
  faGift,
  faGlobe,
  faGraduationCap,
  faHammer,
  faHand,
  faHandHoldingDollar,
  faHandHoldingHeart,
  faHandSparkles,
  faHandshake,
  faHeadphones,
  faHeart,
  faHippo,
  faHourglassHalf,
  faHouse,
  faHouseCircleCheck,
  faHouseLock,
  faHouseSignal,
  faImage,
  faInbox,
  faJugDetergent,
  faKey,
  faKitchenSet,
  faLeaf,
  faLightbulb,
  faLink,
  faList,
  faMagnifyingGlass,
  faMagnifyingGlassDollar,
  faMattressPillow,
  faMoneyBill1Wave,
  faMoneyBillTransfer,
  faMoneyBillTrendUp,
  faMoneyCheck,
  faMoneyCheckDollar,
  faMountain,
  faMountainSun,
  faMuseum,
  faMusic,
  faNotesMedical,
  faPaintRoller,
  faPalette,
  faPaperclip,
  faPassport,
  faPen,
  faPenToSquare,
  faPeopleArrows,
  faPeopleRoof,
  faPerson,
  faPersonBiking,
  faPersonRunning,
  faPersonSkiing,
  faPersonSwimming,
  faPhone,
  faPiggyBank,
  faPills,
  faPlane,
  faPlugCircleBolt,
  faPlus,
  faPoo,
  faQuestion,
  faReceipt,
  faRing,
  faRoad,
  faRobot,
  faRotateLeft,
  faSackDollar,
  faScaleBalanced,
  faSchool,
  faSchoolFlag,
  faScroll,
  faSeedling,
  faShieldDog,
  faShieldHalved,
  faShirt,
  faShop,
  faSliders,
  faSnowflake,
  faSpa,
  faSquareParking,
  faStairs,
  faStar,
  faStethoscope,
  faTag,
  faTicket,
  faToilet,
  faTooth,
  faTrash,
  faTrashCan,
  faTreeCity,
  faTriangleExclamation,
  faTruck,
  faTruckPlane,
  faTv,
  faUmbrellaBeach,
  faUser,
  faUserClock,
  faUserNurse,
  faUtensils,
  faVideo,
  faWandMagicSparkles,
  faWater,
  faWifi,
  faWineGlass,
  faWrench,
  faXmark,
  faXRay,
} from '@fortawesome/free-solid-svg-icons';

const iconsArray = [
  faAnglesRight,
  faArrowLeftLong,
  faArrowRightArrowLeft,
  faArrowRightLong,
  faArrowsRotate,
  faArrowTrendDown,
  faArrowTrendUp,
  faBaby,
  faBabyCarriage,
  faBagShopping,
  faBasketShopping,
  faBath,
  faBed,
  faBell,
  faBellConcierge,
  faBicycle,
  faBinoculars,
  faBoltLightning,
  faBone,
  faBook,
  faBowlFood,
  faBriefcase,
  faBrush,
  faBuildingColumns,
  faBurger,
  faBus,
  faCableCar,
  faCakeCandles,
  faCalculator,
  faCalendar,
  faCalendarDay,
  faCamera,
  faCar,
  faCarBurst,
  faCaretDown,
  faCarrot,
  faCarSide,
  faCartShopping,
  faCat,
  faChair,
  faChartLine,
  faCheck,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faChildren,
  faCircleCheck,
  faCircleDollarToSlot,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlus,
  faCircleQuestion,
  faCircleUser,
  faCircleXmark,
  faClock,
  faCodeFork,
  faCoffee,
  faCoins,
  faComment,
  faCommentsDollar,
  faCompass,
  faCookie,
  faCouch,
  faCreditCard,
  faDice,
  faDog,
  faDroplet,
  faDumbbell,
  faEarth,
  faEnvelope,
  faEye,
  faFaceSmile,
  faFeather,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileLines,
  faFilePen,
  faFire,
  faFireFlameSimple,
  faFish,
  faFishFins,
  faFlask,
  faFolder,
  faFolderOpen,
  faFolderPlus,
  faFolderTree,
  faFutbol,
  faGamepad,
  faGasPump,
  faGauge,
  faGear,
  faGem,
  faGhost,
  faGift,
  faGlobe,
  faGraduationCap,
  faHammer,
  faHand,
  faHandHoldingDollar,
  faHandHoldingHeart,
  faHandSparkles,
  faHandshake,
  faHeadphones,
  faHeart,
  faHippo,
  faHourglassHalf,
  faHouse,
  faHouseCircleCheck,
  faHouseLock,
  faHouseSignal,
  faImage,
  faInbox,
  faJugDetergent,
  faKey,
  faKitchenSet,
  faLeaf,
  faLightbulb,
  faLink,
  faList,
  faMagnifyingGlass,
  faMagnifyingGlassDollar,
  faMattressPillow,
  faMoneyBill1Wave,
  faMoneyBillTransfer,
  faMoneyBillTrendUp,
  faMoneyCheck,
  faMoneyCheckDollar,
  faMountain,
  faMountainSun,
  faMuseum,
  faMusic,
  faNotesMedical,
  faPaintRoller,
  faPalette,
  faPaperclip,
  faPassport,
  faPen,
  faPenToSquare,
  faPeopleArrows,
  faPeopleRoof,
  faPerson,
  faPersonBiking,
  faPersonRunning,
  faPersonSkiing,
  faPersonSwimming,
  faPhone,
  faPiggyBank,
  faPills,
  faPlane,
  faPlugCircleBolt,
  faPlus,
  faPoo,
  faQuestion,
  faReceipt,
  faRing,
  faRoad,
  faRobot,
  faRotateLeft,
  faSackDollar,
  faScaleBalanced,
  faSchool,
  faSchoolFlag,
  faScroll,
  faSeedling,
  faShieldDog,
  faShieldHalved,
  faShirt,
  faShop,
  faSliders,
  faSnowflake,
  faSpa,
  faSquareParking,
  faStairs,
  faStar,
  faStethoscope,
  faTag,
  faTicket,
  faToilet,
  faTooth,
  faTrash,
  faTrashCan,
  faTreeCity,
  faTriangleExclamation,
  faTruck,
  faTruckPlane,
  faTv,
  faUmbrellaBeach,
  faUser,
  faUserClock,
  faUserNurse,
  faUtensils,
  faVideo,
  faWandMagicSparkles,
  faWater,
  faWifi,
  faWineGlass,
  faWrench,
  faXmark,
  faXRay,
];

library.add(...iconsArray);

export { library, FontAwesomeIcon, iconsArray };
